import CreateAttributeList, { componentAttributeTypes, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { GetFontRootColorClass } from "vagaro-website-rendering/src/components/Definitions/ComponentClassHelper";

export default class BusinessName extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessName;
        this.displayName = "Business Name";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation, "bnamelayout", "bnametype"];
        this.editList = [...this.primaryEditAttributes, componentAttributeTypes.multiLocation,attributeTypes.fontColor, ...CreateAttributeList(true, true, true, true, false, false, false)];
        this.resizeType = ResizeableType.All;
        this.vagaroLink = "https://www.vagaro.com/business/businessprofile";
        this.icon = <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.01562 3.5625C6.2793 3.5625 6.54297 3.73828 6.63086 4.00195L8.50586 8.2207C8.68164 8.57227 8.50586 8.98242 8.1543 9.12891C7.80273 9.30469 7.39258 9.12891 7.24609 8.77734L7.09961 8.48438H4.90234L4.75586 8.77734C4.60938 9.12891 4.19922 9.30469 3.84766 9.12891C3.49609 8.98242 3.32031 8.57227 3.49609 8.2207L5.37109 4.00195C5.45898 3.73828 5.72266 3.5625 6.01562 3.5625ZM5.51758 7.07812H6.48438L6.01562 6.02344L5.51758 7.07812ZM9.53125 4.26562C9.53125 3.88477 9.82422 3.5625 10.2344 3.5625H11.7578C12.7246 3.5625 13.5156 4.35352 13.5156 5.32031C13.5156 5.61328 13.4277 5.84766 13.3398 6.08203C13.7207 6.4043 13.9844 6.90234 13.9844 7.42969C13.9844 8.42578 13.1934 9.1875 12.2266 9.1875H10.2344C9.82422 9.1875 9.53125 8.89453 9.53125 8.48438V4.26562ZM10.9375 4.96875V5.67188H11.7578C11.9336 5.67188 12.1094 5.52539 12.1094 5.32031C12.1094 5.14453 11.9336 4.96875 11.7578 4.96875H10.9375ZM10.9375 7.78125H12.2266C12.4023 7.78125 12.5781 7.63477 12.5781 7.42969C12.5781 7.25391 12.4023 7.07812 12.2266 7.07812H10.9375V7.78125ZM0.625 2.625C0.625 1.59961 1.44531 0.75 2.5 0.75H17.5C18.5254 0.75 19.375 1.59961 19.375 2.625V10.125C19.375 11.1797 18.5254 12 17.5 12H2.5C1.44531 12 0.625 11.1797 0.625 10.125V2.625ZM2.03125 2.625V10.125C2.03125 10.3887 2.23633 10.5938 2.5 10.5938H17.5C17.7344 10.5938 17.9688 10.3887 17.9688 10.125V2.625C17.9688 2.39062 17.7344 2.15625 17.5 2.15625H2.5C2.23633 2.15625 2.03125 2.39062 2.03125 2.625Z" fill="#333333" /></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        //setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("bnamelayout", "Text Type", "", AttributeInputType.SelectField, [
                { label: "Default", value: "" },
                { label: "Header 1", value: "h-1" },
                { label: "Header 2", value: "h-2" },
                { label: "Header 3", value: "h-3" },
                { label: "Header 4", value: "h-4" },
                { label: "Paragraph 1", value: "p-1" },
                { label: "Paragraph 2", value: "p-2" },
                { label: "Paragraph 3", value: "p-3" },

            ]),
            new AttributeDefinition("bnametype", "Display Type", "", AttributeInputType.SelectField, [
                { label: "Business Name", value: "" },
                { label: "Business & Owner Name", value: "both" },
                { label: "Owner Name", value: "owner" },

            ]),
        ]
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, "");
        const atts = GetNodeDomAttributes("vb-control businssname max-100 "+GetFontRootColorClass(component) , component, screenSize, isEditor);
        let layout = getNodeComponentAttributeValue(component, "bnamelayout", "");
        let ty = getNodeComponentAttributeValue(component, "bnametype", "");
        if (layout == "") {
            layout = "default";
        }

        layout+=";"+ty;

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="name" layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="name" node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }


}
